<template>
  <power-bi code="eyJrIjoiZWU1YjA4NmYtNmEyMy00MWE3LWFjMWItNWRlMmQxZGJlYmE2IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
